import React, { PropsWithChildren, useState } from "react"
import { ClickAwayListener, Tooltip } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import question_mark from "../../assets/images/icon/question_mark.png"
import question_mark_active from "../../assets/images/icon/question_mark_active.png"

const useStyles = makeStyles((theme) => ({
  icon: {
    verticalAlign: "middle",
    width: "24px",
    marginLeft: "4px",
    color: theme.palette.grey.A100,
  },
  popper: {
    zIndex: 1600,
  },
  arrow: {
    color: "#E8EFFC",
  },
  tooltip: {
    padding: "8px 12px",
    backgroundColor: "#E8EFFC",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 324,
    fontSize: theme.typography.pxToRem(14),
    border: "1px solid #E8EFFC",
    borderRadius: "4px",
  },
}))

interface Props {
  message: NonNullable<React.ReactNode>
}
export function QuestionTooltip({ message }: PropsWithChildren<Props>) {
  const classes = useStyles()
  const [opened, setOpened] = useState(false)
  const handleToggle = () => setOpened(!opened)
  const handleClickAway = () => {
    setOpened(false)
  }

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Tooltip
        title={message}
        placement={"bottom"}
        arrow
        open={opened}
        classes={{ popper: classes.popper, arrow: classes.arrow, tooltip: classes.tooltip }}>
        <img
          className={classes.icon}
          src={opened ? question_mark_active : question_mark}
          onClick={handleToggle}
          alt={"question_mark"}
        />
      </Tooltip>
    </ClickAwayListener>
  )
}
